import React from 'react'

import { useExperianBypassStatus } from 'shared/hooks/useExperianAuth'
import { printDollarsFromCents } from 'shared/utils/dollar-print'

import LumenEntryCard from './LumenEntryCard'
import OutcomesV2 from './OutcomesV2'

import { findLumenResult } from './utils'

const LumenSummary = ({ lumenRun }) => {
  const result = findLumenResult(lumenRun)
  const { hasBypassedAuth } = useExperianBypassStatus();

  return (
    <div className='vega container'>
      <section className='vega flex content'>
        <LumenEntryCard
          label='estimated total annual income'
          result={result}
          valueQuery='total-verified-income'
          valueTransformer={printDollarsFromCents}
          statusQueries={[{ query: 'has-deduped-income', status: 'warn' }]}
          defaultStatus=''
        />

        <LumenEntryCard
          label='total balances'
          result={result}
          valueQuery='total-verified-assets'
          valueTransformer={printDollarsFromCents}
          statusQueries={[{ query: 'has-deduped-asset', status: 'warn' }]}
          defaultStatus=''
        />

        <LumenEntryCard
          label='income to rent ratio'
          result={result}
          valueQuery='income-to-rent'
          statusQueries={[
            { query: 'income-to-rent-ideal', status: 'pass' },
            { query: 'income-to-rent-range-conditional', status: 'warn' }
          ]}
        />

        <LumenEntryCard
          label='cash runway ratio'
          result={result}
          valueQuery='cash-runway'
          statusQueries={[
            { query: 'cash-runway-ideal', status: 'pass' },
            { query: 'cash-runway-range-conditional', status: 'warn' }
          ]}
        />

        {!hasBypassedAuth && (
          <LumenEntryCard
            label='average credit score'
            result={result}
            valueQuery='avg-credit-score'
            statusQueries={[
              { query: ['avg-credit-score-ideal', 'credit-scores-ideal', 'credit-avg-score-ideal'], status: 'pass' },
              { query: ['credit-avg-credit-score-ideal', 'credit-scores-ideal'], status: 'pass' },
              { query: ['avg-credit-score-range-conditional', 'credit-scores-range-conditional', 'credit-avg-score-range-conditional'], status: 'warn' },
              { query: ['credit-avg-credit-score-range-conditional', 'credit-scores-range-conditional'], status: 'warn' }
            ]}
          />
        )}
      </section>

      <OutcomesV2 lumenRun={lumenRun} />
    </div>
  )
}

export default LumenSummary
